import { useContext, useState } from "react";
import { InferType, ObjectSchema } from "yup";
import { FormContext } from "./Form";
import { FormState } from "./Form.types";
import { isRequired } from "./utils";
import { TrixEditor } from "@/ui/atoms/TrixEditor/TrixEditor";
import { Label } from "./Label";
import { ErrorMessage } from "./ErrorMessage";

type FormTrixEditorProps = {
    name: string;
    label: string;
    parent?: string;
    placeholder?: string;
};

export function RichText<T extends ObjectSchema<any>>({
    parent = "",
    ...props
}: FormTrixEditorProps) {
    const [touched, setTouched] = useState(false);
    const name = parent ? `${parent}.${props.name}` : props.name;
    const form = useContext(FormContext) as FormState<T> | undefined;

    if (!form) return null;

    const error = form.errors?.[name] || "";
    const showError =
        touched && error && !error.toLowerCase().includes("required");
    const describedBy = props["aria-describedby"] || `${name}-error`;

    return (
        <div className="my-3 flex flex-col">
            <Label
                name={name}
                label={props.label}
                required={isRequired(form.schema, name)}
            />

            <TrixEditor
                value={form.values[name] || ""}
                onChange={(value) => {
                    setTouched(true);
                    form.updateValue(name as InferType<T>, value);
                }}
            />
            {showError && <ErrorMessage id={describedBy} message={error} />}
        </div>
    );
}
